'use client';
import { FullPageLoading } from '@/shared/components/loading';
import { NEW_ONBOARDING_STEP } from '@/shared/types/welcome';
import { useFetchOnboardingSteps } from '../../hooks/useFetchOnboardingSteps';
import { BasicWorkspaceInfo } from './BasicWorkspaceInfo';

export function BasicWorkspaceInfoMainPage() {
  const {
    isFetchingOnboardingSteps,
    canShowCurrentStep,
    isErrorFetchingOnboardingSteps,
  } = useFetchOnboardingSteps({
    onboardingStep: NEW_ONBOARDING_STEP.basic_workspace_info,
  });

  if (
    isFetchingOnboardingSteps ||
    isErrorFetchingOnboardingSteps ||
    !canShowCurrentStep
  )
    return <FullPageLoading />;

  return <BasicWorkspaceInfo />;
}
